<app-card [collapsible]="true" [startCollapsed]="startCollapsed()">
  <div card-header>
    <h1 class="selected-appliances__title">
      {{ selectedAppliances().length + 1 }} Appliance{{
        selectedAppliances().length ? "s" : ""
      }}
    </h1>
    <app-icon
      [family]="'solid'"
      [name]="'circle-check'"
      [size]="'md'"
      class="selected-appliance-icon"
    />
    @if (customerSelectedToPurchasePlan) {
      @if (hasDiscountedMonths()) {
        <app-single-plan-promo-price />
      } @else {
        <h3>for {{ total() | currencyFormat }} a month</h3>
      }
      <p class="selected-appliances__price-disclaimer">
        {{ "PRICE_TAX_DISCLAIMER" | translate }}
      </p>
    }
  </div>
  <div card-collapsible>
    <hr />
    <h2 class="selected-appliances__appliance-name">
      1. {{ registeredAppliance()?.applianceName }}
    </h2>
    <app-badge-text
      color="blue"
      icon="fa-light fa-file-check"
      text="REGISTERED APPLIANCE"
    />
    <h3>{{ registeredAppliance()?.manufacturer | titlecase }}</h3>
    <h3>
      {{ registeredAppliance()?.purchaseMonth }}
      {{ registeredAppliance()?.purchaseYear }}
    </h3>
    <h3>
      {{ registeredAppliance()?.purchasePrice | priceBand }}
    </h3>
    @for (
      selectedAppliance of selectedAppliances();
      track index;
      let index = $index
    ) {
      <hr />
      <h2 class="selected-appliances__appliance-name">
        {{ index + 2 }}. {{ selectedAppliance.applianceName }}
      </h2>
      <h3>{{ selectedAppliance.brandName | titlecase }}</h3>
      <h3>
        @if (
          selectedAppliance.purchaseMonth !== null &&
          selectedAppliance.wasBoughtWithin12Months
        ) {
          {{ getMonthDate(selectedAppliance.purchaseMonth) | date: "LLLL" }}
        }
        {{ selectedAppliance.purchaseYear }}
      </h3>
      <h3>
        {{ selectedAppliance.purchasePrice | priceBand }}
      </h3>
    }
  </div>
</app-card>
